import consultRoutes from './routes'

/* @ngInject */
const consultRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(consultRoutes.index.path, {
      url: consultRoutes.index.url,
      template: require('./templates/index.html'),
      data: {
        pageTitle: 'Consulter',
      },
    })
}

export default consultRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/consult.routes.js